<div class="overlay">
  <div class="dialog">
    <section class="confirm-delete-container">
      <form (ngSubmit)="onSubmit()">
        <h2 class="bold-text">
          {{ "firstTimeLogin.enterYourPassword" | translate }}
        </h2>
        <h3 class="light-text">{{ "firstTimeLogin.nextStep" | translate }}</h3>

        <app-password-input
          placeholder="New Password"
          [passwordControl]="this.setNewPasswordForm.controls['password']"
        ></app-password-input>
        <br />

        <app-password-input
          placeholder="Confirm Password"
          [passwordControl]="
            this.setNewPasswordForm.controls['confirmPassword']
          "
        ></app-password-input>

        <br />
        <app-dialog-action-buttons
          [config]="{
            cancelButton: true,
            actionButton: true,
            actionButtonConfigs: {
            type: 'button',
            text: 'common.confirm' | translate,
            form: this.setNewPasswordForm
          },
          }"
        ></app-dialog-action-buttons>
      </form>
    </section>
  </div>
</div>
